import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { Candidate } from '@app/models/offer-letters/candidate.model';
import { OfferLetter } from '@app/models/offer-letters/offer-letter.model';

@Injectable()
export class OfferLetterResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'candidate',
            production: {
                find: (id: number) => {
                    return Candidate.with([
                        'latestOfferLetter.cosigners',
                        'latestOfferLetter.cosigners.employee',
                        'latestOfferLetter.cosigners.employee.job',
                        'latestOfferLetter.signingTemplate.document',
                        'latestOfferLetter.signingTemplate.slots',
                        'latestOfferLetter.signingTemplate.slots.assignee',
                        'latestOfferLetter.signingTemplate.slots.assignee.job',
                        'latestOfferLetter.reportsTo',
                        'latestOfferLetter.department',
                        'latestOfferLetter.location',
                        'latestOfferLetter.position',
                        'latestOfferLetter.creator',
                        'latestOfferLetter.creator.job',
                        'employee',
                        'employee.creator',
                    ]).find(id);
                },
            },
        },
        {
            className: 'offerLetter',
            production: {
                find: (id: number) => {
                    return OfferLetter.with([
                        'signingTemplate',
                        'signingTemplate.document',
                        'signingTemplate.slots',
                        'signingTemplate.slots.assignee',
                        'signingTemplate.slots.assignee.job',
                        'reportsTo',
                        'department',
                        'location',
                        'position',
                        'creator',
                    ]).find(id);
                },
            },
        },
    ]);
}
